import homemoto from '../../media/logo.png';
export default function About() {
    return(
        <>
            <div className="container-fluid bg-light p-4">
                <img src={homemoto} className="img-fluid d-block mx-auto shadow rounded-3" style={{ width: 200 }} alt="Homemoto" />
                <h1 className="display-1 text-center text-success">Homemoto</h1>
                <h1 className="display-6 text-center">Your One Stop Shop eCommerce and Real Estate Website</h1>
            </div>
        </>
    )
}